/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailAppMetadata
 */
export interface UserDetailAppMetadata {
    /**
     * 
     */
    mfa_enrolled?: boolean;
    /**
     * 
     */
    mfa_required?: boolean;
    /**
     * 
     */
    mfa_allowed_methods?: Array<string>;
}

/**
 * Check if a given object implements the UserDetailAppMetadata interface.
 */
export function instanceOfUserDetailAppMetadata(value: object): value is UserDetailAppMetadata {
    return true;
}

export function UserDetailAppMetadataFromJSON(json: any): UserDetailAppMetadata {
    return UserDetailAppMetadataFromJSONTyped(json, false);
}

export function UserDetailAppMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailAppMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'mfa_enrolled': json['mfa_enrolled'] == null ? undefined : json['mfa_enrolled'],
        'mfa_required': json['mfa_required'] == null ? undefined : json['mfa_required'],
        'mfa_allowed_methods': json['mfa_allowed_methods'] == null ? undefined : json['mfa_allowed_methods'],
    };
}

export function UserDetailAppMetadataToJSON(json: any): UserDetailAppMetadata {
    return UserDetailAppMetadataToJSONTyped(json, false);
}

export function UserDetailAppMetadataToJSONTyped(value?: UserDetailAppMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mfa_enrolled': value['mfa_enrolled'],
        'mfa_required': value['mfa_required'],
        'mfa_allowed_methods': value['mfa_allowed_methods'],
    };
}

